const productIdQuery = /* GraphQL */ `
	query productId($handle: String) {
		product(handle: $handle) {
			id
		}
	}
`;
export default productIdQuery;
